import { ReactNode } from 'react';
// ייבוא הטוקנים כאן בלבד — opt-in scope (לא מ-index.css)
import '../../styles/profitability-tokens.css';
import styles from './ProfitabilityLayout.module.css';

export interface ProfitabilityLayoutProps {
  /** תוכן המסך */
  children: ReactNode;
  /** class נוסף ל-root */
  className?: string;
}

/**
 * Wrapper layout עבור כל מסכי Profitability.
 *
 * מטעין את ה-design tokens (`--profit-*`) ומגדיר `dir="rtl"` ו-`lang="he"`.
 * זהו הציר היחיד בפרויקט שמייבא את `profitability-tokens.css` — opt-in scope.
 *
 * @example
 * <ProfitabilityLayout>
 *   <MonthlyReport />
 * </ProfitabilityLayout>
 */
export const ProfitabilityLayout = ({
  children,
  className,
}: ProfitabilityLayoutProps): JSX.Element => {
  const rootClass = className ? `${styles.root} ${className}` : styles.root;
  return (
    <div className={rootClass} dir="rtl" lang="he">
      {children}
    </div>
  );
};
